import { Address } from './address';

export class Fbo {
  address: Address;
  id: number;
  name: string;
  phoneNumber: string;
}
